module.exports = __webpack_public_path__ + "static/media/Logo.af9ce348.svg";